<h2 class="sectionTitle">{{ 'FRONT_USER.SUPPLIER_LISTING_REPORT.RATING' | translate }}</h2>

<div class="table-responsive" *ngIf="!showRatedRequest">
  <table class="table table-bordered table-striped table-services">
    <thead>
      <tr>
        <th>{{ 'FRONT_USER.SUPPLIER_LISTING_REPORT.CATEGORY' | translate }}</th>
        <th>{{ 'FRONT_USER.SUPPLIER_LISTING_REPORT.SPECIALITY' | translate }}</th>
        <th>{{ 'FRONT_USER.SUPPLIER_LISTING_REPORT.RATING' | translate }}</th>
      </tr>
    </thead>
    <tbody *ngIf="this.model">

      <tr  *ngFor="let item of model.SupplierSpecialitiesNames; let i = index">
        <td>
          {{item.SpecialityCategoryName}}
        </td>
        <td>{{item.SpecialityName}}</td>
        <td>
          <div class="stars-holder">

                <input [checked]="item.Rating>0" type="radio" name="rating{{i}}" id="rate1{{i}}" (click)="setRating(item.Id,1)" value="1">
                <input [checked]="item.Rating>1" type="radio" name="rating{{i}}" id="rate2{{i}}" (click)="setRating(item.Id,2)" value="2">
                <input [checked]="item.Rating>2" type="radio" name="rating{{i}}" id="rate3{{i}}" (click)="setRating(item.Id,3)" value="3">
                <input [checked]="item.Rating>3" type="radio" name="rating{{i}}" id="rate4{{i}}" (click)="setRating(item.Id,4)" value="4">
                <input [checked]="item.Rating>4" type="radio" name="rating{{i}}" id="rate5{{i}}" (click)="setRating(item.Id,5)" value="5">

                <label for="rate1{{i}}" title="Very Bad"><i class="icon-ratingstar"></i></label>
                <label for="rate2{{i}}" title="Bad"><i class="icon-ratingstar"></i></label>
                <label for="rate3{{i}}" title="Normal"><i class="icon-ratingstar"></i></label>
                <label for="rate4{{i}}" title="Good"><i class="icon-ratingstar"></i></label>
                <label for="rate5{{i}}" title="Excellent"><i class="icon-ratingstar"></i></label>
              </div>
        </td>
      </tr>

    </tbody>
  </table>
  <div class="form-group">
      <button  type="button"  class="btn btn-primary SCAcustomBtn" Confirmation (confirmationClick)="rateSpeciality(model.SupplierSpecialitiesNames)">{{ 'FRONT_USER.SAVE' | translate}}</button>

    </div>
</div>


<div *ngIf="showRatedRequest" class="alert alert-success" role="alert">
    <div class="alignC">
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g>
          <g>
            <path
              d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
            </path>
          </g>
        </g>
      </svg>

      <p>{{ 'FRONT_USER.SUPPLIER_LISTING_REPORT.RATED_SUCCESSFULLY' | translate }}</p>
      <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/SupplierList">
          {{ 'FRONT_USER.SUPPLIER_LISTING_REPORT.SUPPLIER'| translate }}</a></p>
    </div>
  </div>

